import { z } from 'zod';

import { BorrowerId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RemoveAdditionalBorrowerEvent = BaseLoanEvent.extend({
  type: z.literal('removeAdditionalBorrower'),
  borrower: z.object({
    id: BorrowerId,
    name: z.string().optional(),
  }),
});
export type RemoveAdditionalBorrowerEvent = z.infer<typeof RemoveAdditionalBorrowerEvent>;
